import React from 'react';
import { getTheme, Link, Text } from '@fluentui/react';
import { formatGenericEmailHref } from 'components/util';

export const Footer: React.FunctionComponent<Record<string, unknown>> = () => {
  const theme = getTheme();

  return (
    <footer className="w-100" style={{ position: 'absolute', bottom: 0, background: theme.palette.neutralLighterAlt }}>
      <div className="w-100" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Text variant="small" style={{ color: theme.palette.neutralDark }}>
          <span className="pr-4 pl-2">Microsoft Confidential</span>
          <Link
            className="pr-1 mr-4"
            href="http://go.microsoft.com/fwlink/?LinkId=518021"
            rel="noopener noreferrer"
            target="_blank"
            style={{ color: theme.palette.themeDarkAlt }}
          >
            Employee Data Protection Notice
          </Link>
          <Link className="pr-1 mr-4" href={formatGenericEmailHref()} style={{ color: theme.palette.themeDarkAlt }}>
            Feedback
          </Link>
        </Text>
        <Text variant="small" style={{ color: theme.palette.neutralDark }}>
          <span className="pr-4">{process.env.REACT_APP_VERSION}</span>
        </Text>
      </div>
    </footer>
  );
};
